import React, { useState } from 'react';
import classNames from 'classnames/bind';
import { numberWithCommas } from 'app/libs/number';
import dayjs from 'app/libs/dayjs';
import useToast from 'app/hook/common/useToast';
import { testKor } from 'app/libs/regEx';
import IconArrow from 'app/components/common/IconArrow';
import Button from 'app/components/common/Button';
import styles from './CreatedAccountInfo.module.scss';

const cx = classNames.bind(styles);

function CreatedAccountInfo({ title, amount, accountNumber = undefined, bank = undefined, deadline = undefined, button = undefined, collapsible = false, collapseDefaultClose = false, isCompletedPayment = false }) {
	const { notyView } = useToast();
	const [collapsed, setCollapsed] = useState(collapseDefaultClose);

	const onClickAccountNumber = () => {
		const accountNumberElement = document.createElement('input');
		document.body.appendChild(accountNumberElement);
		accountNumberElement.value = `${bank} ${accountNumber}`;
		accountNumberElement.select();
		document.execCommand('copy');
		document.body.removeChild(accountNumberElement);

		notyView({
			id: 'clipboardCopyAlert',
			text: '계좌번호가 복사되었습니다',
			layout: 'bottomCenter',
			timeout: 1000,
		});
	};

	return (
		<div className={cx('account_info', { collapsed })}>
			{collapsible ? (
				<>
					<IconArrow
						className={cx('icon_arrow')}
						direction={collapsed ? 'down' : 'up'}
					/>
					<button
						type="button"
						className={cx('head', 'collapse')}
						onClick={() => setCollapsed((prev) => !prev)}
					>
						{title}
					</button>
				</>
			) : (
				<div className={cx('head')}>{title}</div>
			)}
			{!collapsed && (
				<ul className={cx('info_area')}>
					<li>
						<span className={cx('title')}>{isCompletedPayment ? '입금 완료 금액' : '입금 필요 금액'}</span>
						<span className={cx('text')}>
							<b>{numberWithCommas(amount)}원</b>
						</span>
					</li>
					<li>
						<span className={cx('title')}>입금 계좌</span>
						<span className={cx('text')}>
							{testKor(accountNumber) || isCompletedPayment ? (
								accountNumber
							) : (
								<button
									type="button"
									className={cx('account_number')}
									onClick={onClickAccountNumber}
								>
									{accountNumber}
								</button>
							)}
						</span>
					</li>
					{bank && (
						<li>
							<span className={cx('title')}>입금 은행</span>
							<span className={cx('text')}>{bank}</span>
						</li>
					)}
					{deadline && (
						<li>
							<span className={cx('title')}>입금 기한</span>
							<span className={cx('text')}>{dayjs(deadline).format('MM월 DD일 HH시')}</span>
						</li>
					)}
				</ul>
			)}
			{button && (
				<Button
					color="redline"
					size="40"
					title={button.text}
					style={{ marginTop: 20 }}
					onClick={button.onClick}
				/>
			)}
		</div>
	);
}

export default CreatedAccountInfo;
